<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-major" data-bs-toggle="modal" data-bs-target="#major-modal-form">Klik</button>
        <div class="modal" id="major-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{label}} Data
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="row">
                                    <div class="col-9">                                    
                                        <div class="form-group">
                                            <label class="form-label">Masukan Nama Jurusan<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="form-select-wrapper">
                                                <v-select
                                                    :options="dataMasterMajor"
                                                    label="name"
                                                    v-model="form.master_major"
                                                    placeholder="Pilih Nama Jurusan"
                                                    @input='set_name'
                                                    >
                                                    <template #search="{attributes, events}">
                                                        <input
                                                        class="vs__search"
                                                        :required="!form.master_major"
                                                        v-bind="attributes"
                                                        v-on="events"
                                                        />
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Kode<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" v-model="form.code" required oninvalid="this.setCustomValidity('Masukan kode jurusan')" oninput="this.setCustomValidity('')" placeholder="Kode">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="form-label">Universitas<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <div class="form-select-wrapper form-select-style-1">
                                                <i class="fa-solid fa-caret-down"></i>
                                                <select class="form-select form-select-box-1" v-model="form.university_id" required oninvalid="this.setCustomValidity('Pilih Universitas')" oninput="this.setCustomValidity('')" >
                                                    <option value="">Pilih Universitas</option>
                                                    <option v-for="(item, index) in dataUniversity" :key="index" :value="item.id">{{ item.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Rumpun<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper form-select-style-1">
                                        <i class="fa-solid fa-caret-down"></i>
                                        <select class="form-select form-select-box-1" v-model="form.group_subject_id" required oninvalid="this.setCustomValidity('Pilih Rumpun')" oninput="this.setCustomValidity('')" v-on:change="setSubject">
                                            <option value="">Pilih Rumpun</option>
                                            <option v-for="(item, index) in dataGroupSubject" :key="index" :value="item.id">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="card" v-if="subjectList.length > 0">
                                    <div class="d-block p-3">
                                        <div class="d-block text-sm mb-1">Mata Pelajaran Prasyarat</div>
                                        <div class="d-flex flex-wrap">
                                            <div v-for="(item, index) in subjectList" :key="index" class="d-flex align-items-center py-2 px-3 border rounded me-2 my-1 text-sm">
                                                <div class="me-2">{{ item.name }}</div>
                                                <div class="box-score box-score-sm">
                                                    <span>{{ item.score }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Bonafide<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper form-select-style-1">
                                        <i class="fa-solid fa-caret-down"></i>
                                        <select class="form-select form-select-box-1" v-model="form.bonafide" required oninvalid="this.setCustomValidity('Pilih bonafide')" oninput="this.setCustomValidity('')">
                                            <option value="">Pilih Bonafide</option>
                                            <option value="1">Bonafide</option>
                                            <option value="0">Tidak Bonafide</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Jenjang<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                    <div class="form-select-wrapper form-select-style-1">
                                        <i class="fa-solid fa-caret-down"></i>
                                        <select class="form-select form-select-box-1" v-model="form.education_level" required oninvalid="this.setCustomValidity('Pilih Jenjang')" oninput="this.setCustomValidity('')">
                                            <option value="">Pilih Jenjang</option>
                                            <option value="D3">D3</option>
                                            <option value="D4">D4</option>
                                            <option value="S1">S1</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Kuota SNBP<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan Kuota" v-model="form.snbp_quota" required oninvalid="this.setCustomValidity('Masukan Kuota SNBP')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Peminat SNBP<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan Peminat" v-model="form.snbp_applicants" required oninvalid="this.setCustomValidity('Masukan Peminat SNBP')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Kuota SNBT<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan Kuota" v-model="form.snbt_quota" required oninvalid="this.setCustomValidity('Masukan Kuota snbt')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Peminat SNBT<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="text" class="form-control" placeholder="Masukan Peminat" v-model="form.snbt_applicants" required oninvalid="this.setCustomValidity('Masukan Peminat snbt')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-major">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'MajorForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id                  : "",
                code                : "",
                name                : "",
                university_id       : "",
                group_subject_id    : "",
                bonafide            : "",
                snbp_quota          : "",
                snbp_applicants     : "",
                snbt_quota          : "",
                snbt_applicants     : "",
                education_level     : "",
                master_major        : ""
            },
            dataUniversity   : [],
            dataGroupSubject : [],
            dataMasterMajor : [],
            subjectList      : [],
            university_code  : '',
            submitted        : false,
            waiting          : false
        }
    },
    validations: {
        form: {
            code: {
                required
            },
            name: {
                required
            },
            university_id: {
                required
            },
            group_subject_id: {
                required
            },
            bonafide: {
                required
            },
            snbp_quota: {
                required
            },
            snbp_applicants: {
                required
            },
            snbt_quota: {
                required
            },
            snbt_applicants: {
                required
            },
            education_level: {
                required
            }
        }
    },
    methods: {
        loadForm: function(params="") {
            this.getUniversity();
            this.getGroupSubject();
            this.getMasterMajor();

            if(params == '') {
                this.label = 'Tambah';
                this.university_code = "";
            } else {
                this.label = 'Ubah';
                this.getDataByID(params);
            }

            document.getElementById('btn-modal-major').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-major').click();
            this.$parent.$children[0].$children[0].getData();
            this.university_code = "";
            for (let key in this.form) {
                this.form[key] = '';
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    if(key == 'master_major') {
                        formData.append('master_major', JSON.stringify(this.form.master_major));
                    } else {
                        formData.append(key, this.form[key]);
                    }
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'major/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });

            }
        },
        getDataByID: function(id) {
            if(id != '') {
                let uri         = process.env.VUE_APP_APIHOST+'major/detail';
                this.$http.get(uri,{
                    params : {
                        id : id,
                    }
                }).then(res => {
                    if(res.data.status) {
                        let datasets = res.data.data;

                        for (let key in datasets) {
                            if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                                this.form[key] = datasets[key];

                                if(key == 'group_subject_id') {
                                    this.setSubject();
                                }
                            }
                        }
                    }
                });
            }
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getGroupSubject: function() {
            let uri         = process.env.VUE_APP_APIHOST+'group-subject/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataGroupSubject = res.data.data;
            });
        },
        setCode: function() {
            if(this.form.university_id == '') {
                this.university_code = ""
            } else {
                this.dataUniversity.forEach(element => {
                    if(element.id == this.form.university_id) {
                        this.university_code = element.code
                    }
                });
            }
        },
        setSubject: function() {
            if(this.form.group_subject_id == '') {
                this.subjectList = [];
            } else {
                this.dataGroupSubject.forEach(element => {
                    if(element.id == this.form.group_subject_id) {
                        this.subjectList = element.subject_list;
                    }                    
                });
            }
        },
        getMasterMajor: function() {
            let uri         = process.env.VUE_APP_APIHOST+'master-major/list';
            this.$http.get(uri).then(res => {
                this.dataMasterMajor = res.data.data;
            });
        },
        set_name: function() {
            if(this.form.master_major.id !== undefined) {
                this.form.name = this.form.master_major.name
            }  else {
                this.form.name = "";
            }
        }
    },
}
</script>
